import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { useLang } from "@/i18n";
import { useContact } from "@/components/ContactModal";
import { Brand } from "@/components/Logo";
import { scrollToId } from "@/utils/scroll";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { lang, setLang, t } = useLang();
  const { open: openContact } = useContact();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else scrollToId(id);
  };

  return (
    <header className="site-header" data-testid="site-header">
      <Link to="/" className="brand-link" data-testid="brand-link" aria-label="RKJ GST Consultancy home">
        <Brand />
      </Link>
      <button className="mobile-menu" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
        {open ? <X /> : <Menu />}
      </button>
      <nav className={open ? "nav-links open" : "nav-links"} data-testid="main-navigation">
        <button onClick={() => go("services")} data-testid="nav-services-link">{t("nav.services")}</button>
        <button onClick={() => go("about")} data-testid="nav-about-link">{t("nav.about")}</button>
        <Link to="/blog" onClick={() => setOpen(false)} data-testid="nav-blog-link">{t("nav.journal")}</Link>
        <div className="lang-toggle" role="group" aria-label="Language">
          <button className={lang === "en" ? "lang-btn active" : "lang-btn"} onClick={() => setLang("en")} data-testid="lang-toggle-en">EN</button>
          <button className={lang === "hi" ? "lang-btn active" : "lang-btn"} onClick={() => setLang("hi")} data-testid="lang-toggle-hi">हिंदी</button>
        </div>
        <button className="nav-cta" onClick={() => { setOpen(false); openContact(); }} data-testid="nav-contact-button">
          {t("nav.book")} <ArrowUpRight size={15} />
        </button>
      </nav>
    </header>
  );
}
